<template>
  <b-row class="m-0">
    <b-col>
      <b-card no-body class="overflow-hidden">
        <div slot="header">
          <strong v-text="$lang.newRegisterFormPageTitle" />
        </div>

        <b-card-text class="p-3">
          <b-row>
            <b-col cols="12" md="12">
              <strong
                class="d-flex align-items-center justify-content-between w_max_c mw-100 new_register"
                :class="{
                  'text-danger': !showForm,
                  'text-success': showForm,
                }"
              >
                <label
                  class="mr-3"
                  for="showForm"
                  v-text="$lang.newRegisterFormShowFormText"
                />
                <b-form-checkbox
                  class="mt-2"
                  id="showForm"
                  v-model="showForm"
                />
              </strong>
            </b-col>
          </b-row>
          <b-form @submit.prevent="submit" class="new_register">
            <b-row v-if="showForm" class="mt-3">
              <b-col cols="12" md="12" class="border-top py-3">
                <strong
                  class="border-bottom border-primary pb-1 titr_text required_star"
                  v-text="`${$lang.request_kind}: `"
                />
                <b-form-radio-group
                  class="mt-4"
                  v-model="$v.form.typeRequest.$model"
                  :options="enums.typeRequest"
                >
                  <b-form-invalid-feedback
                    :state="
                      $v.form.typeRequest.$dirty
                        ? !$v.form.typeRequest.$error
                        : null
                    "
                    >{{ $lang.error_required | replace($lang.request_kind) }}
                  </b-form-invalid-feedback>
                </b-form-radio-group>
              </b-col>
              <b-col cols="12" md="12" class="border-top py-3">
                <strong
                  class="border-bottom border-primary pb-1 titr_text required_star"
                  v-text="`${$lang.typeGet}: `"
                />
                <b-alert class="mt-4" variant="danger" show>
                  <i class="fas fa-info-circle mr-2 fa-lg" />
                  <strong v-text="$lang.typeGetTestAlert" />
                </b-alert>

                <b-form-radio-group
                  class="mt-4"
                  v-model="$v.form.typeGet.$model"
                  :options="enums.typeGet"
                >
                  <b-form-invalid-feedback
                    :state="
                      $v.form.typeRequest.$dirty
                        ? !$v.form.typeRequest.$error
                        : null
                    "
                    >{{ $lang.error_required | replace($lang.typeGet) }}
                  </b-form-invalid-feedback>
                </b-form-radio-group>
              </b-col>
              <b-col cols="12" md="12" class="border-top py-3">
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.person_info}: `"
                />
                <b-row class="mx-0 mt-4 py-3 rounded bg-light">
                  <b-col class="py-2" cols="12" md="3">
                    <strong class="mr-2" v-text="`${$lang.mobileNumber}: `" />
                    <span class="value_text" v-text="form.mobile" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong class="mr-2" v-text="`${$lang.name}: `" />
                    <span class="value_text" v-text="form.name" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong class="mr-2" v-text="`${$lang.family}: `" />
                    <span class="value_text" v-text="form.family" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong class="mr-2" v-text="`${$lang.father_name}: `" />
                    <span class="value_text" v-text="form.fatherName" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong class="mr-2" v-text="`${$lang.year_birth}: `" />
                    <span class="value_text" v-text="form.birthDate" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong class="mr-2" v-text="`${$lang.national_code}: `" />
                    <span class="value_text" v-text="form.nationalCode" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong
                      class="mr-2"
                      v-text="`${$lang.birth_certificate}: `"
                    />
                    <span class="value_text" v-text="form.idNumber" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong
                      class="mr-2"
                      v-text="`${$lang.birth_certificate_serial}: `"
                    />
                    <span class="value_text" v-text="form.idSerial" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong
                      class="mr-2"
                      v-text="`${$lang.Place_issuance_identity_card}: `"
                    />
                    <span class="value_text" v-text="form.PlaceIssue" />
                  </b-col>
                  <b-col class="py-2" cols="12" md="3">
                    <strong class="mr-2" v-text="`${$lang.gender}: `" />
                    <span class="value_text" v-text="form.gender" />
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        for="maritalStatus"
                        class="required_star"
                        v-text="`${$lang.marital_status}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-radio-group
                          v-model="$v.form.maritalStatus.$model"
                          :options="enums.maritalStatus"
                        >
                          <b-form-invalid-feedback
                            :state="
                              $v.form.maritalStatus.$dirty
                                ? !$v.form.maritalStatus.$error
                                : null
                            "
                            >{{
                              $lang.error_required
                                | replace($lang.marital_status)
                            }}
                          </b-form-invalid-feedback>
                        </b-form-radio-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="citizenship"
                        v-text="`${$lang.citizenship}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.citizenship.$model"
                          type="text"
                          autocomplete="off"
                          id="citizenship"
                          :placeholder="$lang.citizenship_placeholder"
                          :state="
                            $v.form.citizenship.$dirty
                              ? !$v.form.citizenship.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.citizenship.$dirty
                              ? !$v.form.citizenship.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.citizenship)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="nationality"
                        v-text="`${$lang.nationality}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.nationality.$model"
                          type="text"
                          id="nationality"
                          autocomplete="off"
                          :placeholder="$lang.nationality_placeholder"
                          :state="
                            $v.form.nationality.$dirty
                              ? !$v.form.nationality.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.nationality.$dirty
                              ? !$v.form.nationality.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.citizenship)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="religion"
                        v-text="`${$lang.religion}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-radio-group
                          v-model="$v.form.religion.$model"
                          :options="enums.religion"
                        >
                          <b-form-invalid-feedback
                            :state="
                              $v.form.religion.$dirty
                                ? !$v.form.religion.$error
                                : null
                            "
                            >{{
                              $lang.error_required | replace($lang.religion)
                            }}
                          </b-form-invalid-feedback>
                        </b-form-radio-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="religiosity"
                        v-text="`${$lang.allegiance}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.religiosity.$model"
                          type="text"
                          id="religiosity"
                          autocomplete="off"
                          :placeholder="$lang.allegiance_placeholder"
                          :state="
                            $v.form.religiosity.$dirty
                              ? !$v.form.religiosity.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.religiosity.$dirty
                              ? !$v.form.religiosity.$error
                              : null
                          "
                        >
                          {{ $lang.error_required | replace($lang.allegiance) }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    tag="strong"
                    cols="12"
                    md="12"
                    class="mb-3 text-info"
                    v-text="$lang.contactPerson"
                  />
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        v-text="`${$lang.city_address}: `"
                      />
                      <b-col cols="12" md="6">
                        <selectAsync
                          :options="enums.cities"
                          v-model="$v.form.city.$model"
                          label="caption"
                          :asyncFind="getCities"
                          :loading="status.cities"
                          :placeholder="$lang.search_city"
                          :isValid="
                            $v.form.city.$dirty ? !$v.form.city.$error : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.city.$dirty ? !$v.form.city.$error : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.city_address)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="homeAddress"
                        v-text="`${$lang.home_address}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.homeAddress.$model"
                          type="text"
                          id="homeAddress"
                          :placeholder="$lang.home_address_placeholder"
                          :state="
                            $v.form.homeAddress.$dirty
                              ? !$v.form.homeAddress.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.homeAddress.$dirty
                              ? !$v.form.homeAddress.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.home_address)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="postalCode"
                        v-text="`${$lang.postal_code}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.postalCode.$model"
                          type="text"
                          id="postalCode"
                          :placeholder="$lang.postal_code_placeholder"
                          :state="
                            $v.form.postalCode.$dirty
                              ? !$v.form.postalCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.postalCode.$dirty
                              ? !$v.form.postalCode.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.postal_code)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="phone"
                        v-text="`${$lang.home_phone}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.phone.$model"
                          type="text"
                          id="phone"
                          :placeholder="$lang.home_phone_placeholder"
                          :state="
                            $v.form.phone.$dirty ? !$v.form.phone.$error : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.phone.$dirty ? !$v.form.phone.$error : null
                          "
                        >
                          {{ $lang.error_required | replace($lang.home_phone) }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="email"
                        v-text="`${$lang.email}`"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.email.$model"
                          type="text"
                          id="email"
                          :placeholder="$lang.email_placeholder"
                          :state="
                            $v.form.email.$dirty ? !$v.form.email.$error : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.email.$dirty ? !$v.form.email.$error : null
                          "
                        >
                          {{ $lang.error_required | replace($lang.email) }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    tag="strong"
                    cols="12"
                    md="12"
                    class="mb-3 text-info"
                    v-text="`${$lang.job_info}`"
                  />
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="currentJob"
                        v-text="`${$lang.current_job}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.currentJob.$model"
                          type="text"
                          id="currentJob"
                          :placeholder="$lang.job_placeholder"
                          :state="
                            $v.form.currentJob.$dirty
                              ? !$v.form.currentJob.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.currentJob.$dirty
                              ? !$v.form.currentJob.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.current_job)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        v-text="`${$lang.work_city_address}: `"
                      />
                      <b-col cols="12" md="6">
                        <selectAsync
                          :options="enums.cities"
                          v-model="$v.form.workCity.$model"
                          label="caption"
                          :asyncFind="getCities"
                          :loading="status.cities"
                          :placeholder="$lang.search_city"
                          :isValid="
                            $v.form.workCity.$dirty
                              ? !$v.form.workCity.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.workCity.$dirty
                              ? !$v.form.workCity.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.work_city_address)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col class="mb-3" cols="12" md="12">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="workAddress"
                        v-text="`${$lang.work_address}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.workAddress.$model"
                          type="text"
                          id="workAddress"
                          :placeholder="$lang.home_address_placeholder"
                          :state="
                            $v.form.workAddress.$dirty
                              ? !$v.form.workAddress.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.workAddress.$dirty
                              ? !$v.form.workAddress.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.work_address)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="form.gender === 'male' && this.form.typeGet !== 2"
                cols="12"
                md="12"
                class="border-top py-3"
              >
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.military_info}: `"
                />
                <b-row class="mt-4">
                  <b-col cols="12" md="12" class="mb-3">
                    <b-row>
                      <b-col
                        cols="12"
                        md="2"
                        class="pt-2 required_star"
                        v-text="`${$lang.militaryServiceStatus}: `"
                      />
                      <b-col cols="12" md="6">
                        <selectFind
                          :options="enums.militaryServiceStatus"
                          v-model="$v.form.militaryServiceStatus.$model"
                          label="text"
                          :loading="status.militaryServiceStatus"
                          :isValid="
                            $v.form.militaryServiceStatus.$dirty
                              ? !$v.form.militaryServiceStatus.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.militaryServiceStatus.$dirty
                              ? !$v.form.militaryServiceStatus.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.militaryServiceStatus)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mb-3">
                    <b-row align-v="center">
                      <b-col
                        cols="12"
                        md="2"
                        class="pt-2 required_star"
                        tag="label"
                        for="military_field_2"
                        v-text="`${$lang.militaryServiceSerialCard}`"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.militaryServiceSerialCard.$model"
                          type="text"
                          id="military_field_2"
                          :placeholder="$lang.postal_code_placeholder"
                          :state="
                            $v.form.militaryServiceSerialCard.$dirty
                              ? !$v.form.militaryServiceSerialCard.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.militaryServiceSerialCard.$dirty
                              ? !$v.form.militaryServiceSerialCard.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.militaryServiceSerialCard)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mb-3">
                    <b-row>
                      <b-col
                        cols="12"
                        md="2"
                        class="pt-2 required_star"
                        for="military_field_3"
                        v-text="`${$lang.date_issuance_duty_system_card}: `"
                      />
                      <b-col cols="12" md="6">
                        <date-picker
                          v-model="$v.form.militaryServiceCardDate.$model"
                          display-format="jYYYY/jMM/jDD"
                          format="YYYY-MM-DD"
                          type="date"
                          id="military_field_3"
                          clearable
                          :placeholder="$lang.date_placeholder"
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.militaryServiceCardDate.$dirty
                              ? !$v.form.militaryServiceCardDate.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.date_issuance_duty_system_card)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="12" class="border-top py-3">
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.specialTestingConditions}: `"
                />
                <b-form-checkbox-group
                  class="mt-4"
                  v-model="$v.form.specialTestingConditions.$model"
                  :options="enums.specialTestingConditions"
                  name="specialTestingConditions"
                >
                  <b-form-invalid-feedback
                    :state="
                      $v.form.specialTestingConditions.$dirty
                        ? !$v.form.specialTestingConditions.$error
                        : null
                    "
                  >
                    {{
                      $lang.error_required
                        | replace($lang.specialTestingConditions)
                    }}
                  </b-form-invalid-feedback>
                </b-form-checkbox-group>
                <b-row align-v="center" class="mt-4">
                  <b-col
                    tag="label"
                    cols="12"
                    md="2"
                    class=""
                    for="typeDisabilityApproved"
                    v-text="`${$lang.typeDisabilityApproved}: `"
                  />
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="$v.form.typeDisabilityApproved.$model"
                      type="text"
                      id="typeDisabilityApproved"
                      :placeholder="$lang.typeDisabilityApproved_placeholder"
                      :state="
                        $v.form.typeDisabilityApproved.$dirty
                          ? !$v.form.typeDisabilityApproved.$error
                          : null
                      "
                    />
                    <b-form-invalid-feedback
                      :state="
                        $v.form.typeDisabilityApproved.$dirty
                          ? !$v.form.typeDisabilityApproved.$error
                          : null
                      "
                    >
                      {{
                        $lang.error_required
                          | replace($lang.typeDisabilityApproved)
                      }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="12" class="border-top py-3">
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.educational_status}: `"
                />
                <small
                  class="text-info"
                  v-text="$lang.Last_educational_certificate"
                />
                <b-row class="mt-4">
                  <b-col cols="12" md="12" class="mb-3">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        v-text="`${$lang.gradeEducation}: `"
                      />
                      <b-col cols="12" md="6">
                        <selectFind
                          :options="enums.grade"
                          v-model="$v.form.grade.$model"
                          label="text"
                          :loading="status.grade"
                          :isValid="
                            $v.form.grade.$dirty ? !$v.form.grade.$error : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.grade.$dirty ? !$v.form.grade.$error : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.gradeEducation)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mb-3">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="fieldAcademic"
                        v-text="`${$lang.fieldAcademic}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.fieldAcademic.$model"
                          type="text"
                          id="fieldAcademic"
                          :placeholder="$lang.fieldAcademic_placeholder"
                          :state="
                            $v.form.fieldAcademic.$dirty
                              ? !$v.form.fieldAcademic.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.fieldAcademic.$dirty
                              ? !$v.form.fieldAcademic.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.fieldAcademic)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mb-3">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="university"
                        v-text="`${$lang.university}: `"
                      />
                      <b-col cols="12" md="6">
                        <b-form-input
                          v-model="$v.form.university.$model"
                          type="text"
                          id="university"
                          :placeholder="$lang.university_placeholder"
                          :state="
                            $v.form.university.$dirty
                              ? !$v.form.university.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.university.$dirty
                              ? !$v.form.university.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.education_place)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mb-3">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        cols="12"
                        md="2"
                        class="required_star"
                        for="yearGraduation"
                        v-text="`${$lang.yearGraduation}: `"
                      />
                      <b-col cols="12" md="6">
                        <date-picker
                          v-model="$v.form.yearGraduation.$model"
                          display-format="jYYYY"
                          format="YYYY"
                          type="year"
                          id="yearGraduation"
                          clearable
                          simple
                          :placeholder="$lang.yearGraduation_placeholder"
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.yearGraduation.$dirty
                              ? !$v.form.yearGraduation.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.yearGraduation)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="form.typeRequest === 2"
                cols="12"
                md="12"
                class="border-top py-3"
              >
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.workExperience}: `"
                />
                <small class="text-info" v-text="$lang.workExperienceCaption" />
                <b-row align-v="center" class="mt-4">
                  <b-col
                    tag="label"
                    cols="12"
                    md="2"
                    class="required_star"
                    for="workExperienceMonths"
                    v-text="`${$lang.workExperienceMonths}: `"
                  />
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="$v.form.workExperienceMonths.$model"
                      type="number"
                      id="workExperienceMonths"
                      :placeholder="$lang.workExperienceMonths_placeholder"
                      :state="
                        $v.form.workExperienceMonths.$dirty
                          ? !$v.form.workExperienceMonths.$error
                          : null
                      "
                    />
                    <b-form-invalid-feedback
                      :state="
                        $v.form.workExperienceMonths.$dirty
                          ? !$v.form.workExperienceMonths.$error
                          : null
                      "
                    >
                      {{
                        $lang.error_required | replace($lang.workExperience2)
                      }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="12"
                md="12"
                class="border-top py-3"
                v-if="this.form.typeGet !== 2"
              >
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="$lang.quota"
                />
                <b-alert class="mt-4" variant="danger" show>
                  <i class="fas fa-info-circle mr-2 fa-lg" />
                  <strong v-text="$lang.quotaAlertText" />
                </b-alert>
                <b-row align-v="center" class="mt-4">
                  <b-col
                    tag="strong"
                    cols="12"
                    md="2"
                    class="required_star pt-2"
                    v-text="`${$lang.quotaStatus}: `"
                  />
                  <b-col cols="12" md="6">
                    <b-form-radio-group
                      class="mt-2"
                      v-model="$v.form.quotaStatus.$model"
                      :options="enums.quotaStatus"
                    />
                    <b-form-invalid-feedback
                      :state="
                        $v.form.quotaStatus.$dirty
                          ? !$v.form.quotaStatus.$error
                          : null
                      "
                    >
                      {{ $lang.error_required | replace($lang.quotaStatus) }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row v-if="form.quotaStatus" class="border-top mt-4 py-4">
                  <b-col cols="12" md="6">
                    <b-row class="mb-3">
                      <b-col
                        tag="strong"
                        v-text="`${$lang.quotaStatusMore}: `"
                      />
                    </b-row>
                    <b-form-checkbox-group
                      class="mt-2"
                      v-model="$v.form.quotaStatusMore.$model"
                      :options="enums.quotaStatusMore"
                      name="quotaStatusMore"
                      stacked
                    >
                      <b-form-invalid-feedback
                        :state="
                          $v.form.quotaStatusMore.$dirty
                            ? !$v.form.quotaStatusMore.$error
                            : null
                        "
                      >
                        {{
                          $lang.error_required | replace($lang.quotaStatusMore)
                        }}
                      </b-form-invalid-feedback>
                    </b-form-checkbox-group>
                  </b-col>
                  <b-col cols="12" md="6" class="border-right">
                    <b-row class="mb-3">
                      <b-col
                        tag="strong"
                        v-text="`${$lang.sacrificer_info}: `"
                      />
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_1"
                        v-text="`${$lang.name}: `"
                      />
                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerName.$model"
                          type="text"
                          id="quota_field_1"
                          :placeholder="$lang.namePlaceholder"
                          :state="
                            $v.form.sacrificerName.$dirty
                              ? !$v.form.sacrificerName.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerName.$dirty
                              ? !$v.form.sacrificerName.$error
                              : null
                          "
                        >
                          {{ $lang.error_required | replace($lang.name) }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_2"
                        v-text="`${$lang.family}: `"
                      />

                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerFamily.$model"
                          type="text"
                          id="quota_field_2"
                          :placeholder="$lang.familyPlaceholder"
                          :state="
                            $v.form.sacrificerFamily.$dirty
                              ? !$v.form.sacrificerFamily.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerFamily.$dirty
                              ? !$v.form.sacrificerFamily.$error
                              : null
                          "
                        >
                          {{ $lang.error_required | replace($lang.family) }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        for="quota_field_3"
                        v-text="`${$lang.national_code}: `"
                      />
                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerNationalCode.$model"
                          type="number"
                          id="quota_field_3"
                          :placeholder="$lang.postal_code_placeholder"
                          :state="
                            $v.form.sacrificerNationalCode.$dirty
                              ? !$v.form.sacrificerNationalCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerNationalCode.$dirty
                              ? !$v.form.sacrificerNationalCode.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.national_code)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_4"
                        v-text="`${$lang.birth_certificate}: `"
                      />
                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerIdNumber.$model"
                          type="number"
                          id="quota_field_4"
                          :placeholder="$lang.postal_code_placeholder"
                          :state="
                            $v.form.sacrificerIdNumber.$dirty
                              ? !$v.form.sacrificerIdNumber.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerIdNumber.$dirty
                              ? !$v.form.sacrificerIdNumber.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.birth_certificate)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_5"
                        v-text="`${$lang.father_name}: `"
                      />
                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerFatherName.$model"
                          type="text"
                          id="quota_field_5"
                          :placeholder="$lang.namePlaceholder"
                          :state="
                            $v.form.sacrificerFatherName.$dirty
                              ? !$v.form.sacrificerFatherName.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerFatherName.$dirty
                              ? !$v.form.sacrificerFatherName.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required | replace($lang.father_name)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="sacrificerBirthDate"
                        v-text="`${$lang.birth_date}: `"
                      />
                      <b-col cols="12" md="">
                        <date-picker
                          v-model="$v.form.sacrificerBirthDate.$model"
                          display-format="jYYYY/jMM/jDD"
                          format="YYYY-MM-DD"
                          type="date"
                          id="sacrificerBirthDate"
                          clearable
                          :placeholder="$lang.date_placeholder"
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerBirthDate.$dirty
                              ? !$v.form.sacrificerBirthDate.$error
                              : null
                          "
                        >
                          {{ $lang.error_required | replace($lang.birth_date) }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_6"
                        v-text="`${$lang.quotaCode}: `"
                      />
                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerCode.$model"
                          type="number"
                          id="quota_field_6"
                          :placeholder="$lang.postal_code_placeholder"
                          :state="
                            $v.form.sacrificerCode.$dirty
                              ? !$v.form.sacrificerCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerCode.$dirty
                              ? !$v.form.sacrificerCode.$error
                              : null
                          "
                        >
                          {{ $lang.error_required | replace($lang.quotaCode) }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_7"
                        v-text="`${$lang.sacrificerPreCode}: `"
                      />
                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerPreCode.$model"
                          type="number"
                          id="quota_field_7"
                          :placeholder="$lang.postal_code_placeholder"
                          :state="
                            $v.form.sacrificerPreCode.$dirty
                              ? !$v.form.sacrificerPreCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerPreCode.$dirty
                              ? !$v.form.sacrificerPreCode.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.sacrificerPreCode)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_8"
                        v-text="`${$lang.duration_presence_front_month}: `"
                      />
                      <b-col cols="12" md="">
                        <b-form-input
                          v-model="$v.form.sacrificerTime.$model"
                          type="number"
                          id="quota_field_8"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.sacrificerTime.$dirty
                              ? !$v.form.sacrificerTime.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerTime.$dirty
                              ? !$v.form.sacrificerTime.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.duration_presence_front)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mb-2">
                      <b-col
                        tag="label"
                        cols="12"
                        md="5"
                        class="required_star"
                        for="quota_field_9"
                        v-text="`${$lang.sacrificerCompany}: `"
                      />
                      <b-col cols="12" md="">
                        <selectFind
                          :options="enums.sacrificerCompany"
                          v-model="$v.form.sacrificerCompany.$model"
                          label="text"
                          :loading="status.sacrificerCompany"
                          id="quota_field_9"
                          :isValid="
                            $v.form.sacrificerCompany.$dirty
                              ? !$v.form.sacrificerCompany.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.sacrificerCompany.$dirty
                              ? !$v.form.sacrificerCompany.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.sacrificerCompany)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="form.typeGet === 3 && includes(form.typeRequest, [1, 3])"
                cols="12"
                md="12"
                class="border-top py-3"
              >
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.advocacyLicenseTitr}: `"
                />
                <b-row align-v="center">
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="advocacyLicenseNumber"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.advocacyLicenseNumber}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.advocacyLicenseNumber.$model"
                          type="number"
                          id="advocacyLicenseNumber"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.advocacyLicenseNumber.$dirty
                              ? !$v.form.advocacyLicenseNumber.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.advocacyLicenseNumber.$dirty
                              ? !$v.form.advocacyLicenseNumber.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.advocacyLicenseNumber)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="ofJurisprudenceCode"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.ofJurisprudenceCode}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.ofJurisprudenceCode.$model"
                          type="number"
                          id="ofJurisprudenceCode"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.ofJurisprudenceCode.$dirty
                              ? !$v.form.ofJurisprudenceCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.ofJurisprudenceCode.$dirty
                              ? !$v.form.ofJurisprudenceCode.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.ofJurisprudenceCode)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="toJurisprudenceCode"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.toJurisprudenceCode}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.toJurisprudenceCode.$model"
                          type="number"
                          id="toJurisprudenceCode"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.toJurisprudenceCode.$dirty
                              ? !$v.form.toJurisprudenceCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.toJurisprudenceCode.$dirty
                              ? !$v.form.toJurisprudenceCode.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.toJurisprudenceCode)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="form.typeGet === 4 && includes(form.typeRequest, [2, 3])"
                cols="12"
                md="12"
                class="border-top py-3"
              >
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.undergraduateLicenseNumberTitr}: `"
                />
                <b-row align-v="center">
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="undergraduateLicenseNumber"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.undergraduateLicenseNumber}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.undergraduateLicenseNumber.$model"
                          type="number"
                          id="undergraduateLicenseNumber"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.undergraduateLicenseNumber.$dirty
                              ? !$v.form.undergraduateLicenseNumber.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.undergraduateLicenseNumber.$dirty
                              ? !$v.form.undergraduateLicenseNumber.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.undergraduateLicenseNumber)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="ofUndergraduateFieldCode"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.ofUndergraduateFieldCode}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.ofUndergraduateFieldCode.$model"
                          type="number"
                          id="ofUndergraduateFieldCode"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.ofUndergraduateFieldCode.$dirty
                              ? !$v.form.ofUndergraduateFieldCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.ofUndergraduateFieldCode.$dirty
                              ? !$v.form.ofUndergraduateFieldCode.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.ofUndergraduateFieldCode)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="toUndergraduateFieldCode"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.toUndergraduateFieldCode}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.toUndergraduateFieldCode.$model"
                          type="number"
                          id="toUndergraduateFieldCode"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.toUndergraduateFieldCode.$dirty
                              ? !$v.form.toUndergraduateFieldCode.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.toUndergraduateFieldCode.$dirty
                              ? !$v.form.toUndergraduateFieldCode.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.toUndergraduateFieldCode)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="includes(form.typeGet, [1, 2])"
                cols="12"
                md="12"
                class="border-top py-3"
              >
                <strong
                  class="border-bottom border-primary pb-1 titr_text"
                  v-text="`${$lang.jurisdictionStatus}: `"
                />
                <b-row>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-alert variant="info" show>
                      <strong v-text="$lang.jurisdictionStatusAlert" />
                    </b-alert>
                  </b-col>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="cityOrStringCode1"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.cityOrStringCode1}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.cityOrStringCode1.$model"
                          type="number"
                          id="cityOrStringCode1"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.cityOrStringCode1.$dirty
                              ? !$v.form.cityOrStringCode1.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.cityOrStringCode1.$dirty
                              ? !$v.form.cityOrStringCode1.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.cityOrStringCode1)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="cityOrStringCode2"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.cityOrStringCode2}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.cityOrStringCode2.$model"
                          type="number"
                          id="cityOrStringCode2"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.cityOrStringCode2.$dirty
                              ? !$v.form.cityOrStringCode2.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.cityOrStringCode2.$dirty
                              ? !$v.form.cityOrStringCode2.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.cityOrStringCode2)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" class="mt-4">
                    <b-row align-v="center">
                      <b-col
                        tag="label"
                        for="cityOrStringCode3"
                        cols="12"
                        md="3"
                        class="required_star"
                        v-text="`${$lang.cityOrStringCode3}: `"
                      />
                      <b-col cols="12" md="5">
                        <b-form-input
                          v-model="$v.form.cityOrStringCode3.$model"
                          type="number"
                          id="cityOrStringCode3"
                          :placeholder="$lang.workExperienceMonths_placeholder"
                          :state="
                            $v.form.cityOrStringCode3.$dirty
                              ? !$v.form.cityOrStringCode3.$error
                              : null
                          "
                        />
                        <b-form-invalid-feedback
                          :state="
                            $v.form.cityOrStringCode3.$dirty
                              ? !$v.form.cityOrStringCode3.$error
                              : null
                          "
                        >
                          {{
                            $lang.error_required
                              | replace($lang.cityOrStringCode3)
                          }}
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="showForm" class="m-0">
              <b-col cols="12" md="12" class="bg-light rounded py-3">
                <b-form-checkbox
                  class="mt-2"
                  id="acceptForm"
                  v-model="acceptForm"
                >
                  <strong
                    :class="{
                      'text-danger': !acceptForm,
                      'text-success': acceptForm,
                    }"
                    v-text="$lang.acceptFormText"
                  />
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row v-if="showForm" align-v="center" align-h="end" class="mt-3">
              <b-col cols="6" md="2" v-if="acceptForm">
                <b-button
                  type="submit"
                  block
                  variant="primary"
                  v-text="$lang.register_and_send"
                />
              </b-col>
              <b-col cols="6" md="2">
                <b-button
                  @click="$router.push('/')"
                  type="reset"
                  block
                  variant="outline-danger"
                  v-text="$lang.cancelButton"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-card-text>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { includes, pathOr } from "ramda";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  validations: {
    form: {
      typeRequest: {
        required,
      },
      typeGet: {
        required,
      },
      maritalStatus: {
        required,
      },
      citizenship: {
        required,
      },
      nationality: {
        required,
      },
      religion: {
        required,
      },
      religiosity: {
        required,
      },
      phone: {
        required,
      },
      city: {
        required,
      },
      homeAddress: {
        required,
      },
      postalCode: {
        required,
      },
      email: {
        required,
      },
      currentJob: {
        required,
      },
      workCity: {
        required,
      },
      workAddress: {
        required,
      },
      militaryServiceStatus: {
        required,
      },
      militaryServiceSerialCard: {
        required,
      },
      militaryServiceCardDate: {
        required,
      },
      specialTestingConditions: {},
      typeDisabilityApproved: {},
      fieldAcademic: {
        required,
      },
      grade: {
        required,
      },
      university: {
        required,
      },
      yearGraduation: {
        required,
      },
      workExperienceMonths: {
        required,
      },
      quotaStatus: {
        required,
      },
      quotaStatusMore: {
        required,
      },
      sacrificerName: {
        required,
      },
      sacrificerFamily: {
        required,
      },
      sacrificerNationalCode: {
        required,
      },
      sacrificerIdNumber: {
        required,
      },
      sacrificerFatherName: {
        required,
      },
      sacrificerBirthDate: {
        required,
      },
      sacrificerCode: {
        required,
      },
      sacrificerPreCode: {
        required,
      },
      sacrificerTime: {
        required,
      },
      sacrificerCompany: {
        required,
      },
      advocacyLicenseNumber: {
        required,
      },
      ofJurisprudenceCode: {
        required,
      },
      toJurisprudenceCode: {
        required,
      },
      undergraduateLicenseNumber: {
        required,
      },
      ofUndergraduateFieldCode: {
        required,
      },
      toUndergraduateFieldCode: {
        required,
      },
      cityOrStringCode1: {
        required,
      },
      cityOrStringCode2: {
        required,
      },
      cityOrStringCode3: {
        required,
      },
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    keyServies: {
      type: String,
      default: "person",
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showForm: false,
      acceptForm: false,
      form: {
        typeRequest: "",
        typeGet: "",
        mobile: "",
        name: "",
        family: "",
        fatherName: "",
        birthDate: "",
        nationalCode: "",
        idNumber: "",
        idSerial: "",
        PlaceIssue: "",
        gender: "male",
        maritalStatus: "",
        citizenship: "",
        nationality: "",
        religion: "",
        religiosity: "",
        phone: "",
        city: "",
        homeAddress: "",
        postalCode: "",
        email: "",
        currentJob: "",
        workCity: "",
        workAddress: "",
        militaryServiceStatus: "",
        militaryServiceSerialCard: "",
        militaryServiceCardDate: "",
        specialTestingConditions: [],
        typeDisabilityApproved: "",
        fieldAcademic: "",
        grade: "",
        university: "",
        yearGraduation: "",
        workExperienceMonths: "",
        quotaStatus: "",
        quotaStatusMore: [],
        sacrificerName: "",
        sacrificerFamily: "",
        sacrificerNationalCode: "",
        sacrificerIdNumber: "",
        sacrificerFatherName: "",
        sacrificerBirthDate: "",
        sacrificerCode: "",
        sacrificerPreCode: "",
        sacrificerTime: "",
        sacrificerCompany: "",
        advocacyLicenseNumber: "",
        ofJurisprudenceCode: "",
        toJurisprudenceCode: "",
        undergraduateLicenseNumber: "",
        ofUndergraduateFieldCode: "",
        toUndergraduateFieldCode: "",
        cityOrStringCode1: "",
        cityOrStringCode2: "",
        cityOrStringCode3: "",
      },
      status: {
        maritalStatus: false,
        religion: false,
        militaryServiceStatus: false,
        grade: false,
        sacrificerCompany: false,
        cities: false,
      },
      enums: {
        typeRequest: [],
        typeGetNetwork: [],
        typeGet: [],
        maritalStatus: [],
        religion: [],
        cities: [],
        militaryServiceStatus: [],
        specialTestingConditions: [],
        grade: [],
        quotaStatus: [],
        quotaStatusMore: [],
        sacrificerCompany: [],
      },
    };
  },
  watch: {
    form: {
      handler(items) {
        this.typeRequestWatcher(items.typeRequest);
      },
      deep: true,
    },
  },
  methods: {
    includes,
    pathOr,
    typeRequestWatcher(typeRequest = null) {
      // keep changeable keys of typeGet options
      const addedData = [
        "",
        this.enums.typeGetNetwork[2],
        this.enums.typeGetNetwork[3],
        [this.enums.typeGetNetwork[2], this.enums.typeGetNetwork[3]],
      ];

      // get default options in first load
      this.enums.typeGet = [
        this.enums.typeGetNetwork[0],
        this.enums.typeGetNetwork[1],
      ];

      // when checked typeRequest option
      if (typeRequest && addedData[typeRequest]) {
        this.enums.typeGet.splice(2);
        typeRequest !== 3 && this.enums.typeGet.push(addedData[typeRequest]);
      }
    },
    async getEnums(target, enumName, func = null) {
      this.status[enumName] = true;
      try {
        this.$config.metaData.marriage;
        let url = `${this.$config.api_url}${target}`;
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.enums[enumName] = [
          ...data.map((item) => {
            return {
              value: item.enum_id,
              text: item.enum_caption,
            };
          }),
        ];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.status[enumName] = false;
        func && func();
      }
    },
    async getCities(query) {
      if (!query || query.length < 2) {
        return;
      }
      this.status.cities = true;
      try {
        let url =
          this.$config.api_url +
          this.$config.resources.location +
          `?city=${query}`;
        const response = await this.$httpService.get(url);
        this.enums.cities = [...pathOr([], ["data", "data"], response)];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.status.cities = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      alert("dont check validate");
    },
  },
  async created() {
    await this.getEnums(
      `${this.$config.resources.enum}/license_type`,
      "typeRequest"
    );
    await this.getEnums(
      `${this.$config.resources.enum}/testing_target`,
      "typeGetNetwork",
      () => this.typeRequestWatcher()
    );
    await this.getEnums(
      `${this.$config.resources.enum}/testing_conditions`,
      "specialTestingConditions"
    );
    await this.getEnums(
      `${this.$config.resources.enum}/has_hasnt`,
      "quotaStatus"
    );
    await this.getEnums(this.$config.metaData.marriage, "maritalStatus", () =>
      this.enums.maritalStatus.splice(2)
    );
    await this.getEnums(`${this.$config.resources.enum}/religion`, "religion");
    await this.getEnums(
      `${this.$config.resources.enum}/military_type`,
      "militaryServiceStatus"
    );
    await this.getEnums(
      `${this.$config.resources.enum}/education_grade`,
      "grade"
    );
    await this.getEnums(
      `${this.$config.resources.enum}/sacrificer_type`,
      "quotaStatusMore"
    );
    await this.getEnums(
      `${this.$config.resources.enum}/sacrificer_organize`,
      "sacrificerCompany"
    );
  },
};
</script>

<style lang="scss" scope>
.required_star {
  &::after {
    content: "*";
    font-size: 18px;
    color: red;
    position: absolute;
    margin-right: 2px;
  }
}

.new_register .custom-control-label,
.value_text {
  padding-top: 1px;
  color: #6d6d6d;
  font-weight: 500;
  font-size: 13px;
}
.titr_text {
  font-size: 16px;
}

.new_register .custom-checkbox {
  margin-bottom: 15px;
}

.new_register
  .custom-control-input:focus
  ~ .new_register
  .custom-control-label::before,
.new_register
  .custom-control-input:focus:not(:checked)
  ~ .custom-control-label::before {
  box-shadow: none;
  border-color: #c7cdd3;
}
.new_register .custom-checkbox .custom-control-label::before {
  border-radius: 4px;
}
.new_register .custom-radio .custom-control-label::before {
  border-radius: 25px;
}

.new_register .custom-control-label::before {
  background-image: none;
  border: 2px solid #c7cdd3;
  background-color: transparent;
}
.new_register
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::after {
  border-radius: 4px;
  box-shadow: none;
}
.new_register
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  border-radius: 25px;
  box-shadow: none;
}

.new_register .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none;
  border: 2px solid #c7cdd3;
  border-radius: 25px;
  background-color: transparent;
}
.new_register .custom-control-input:checked ~ .custom-control-label::before {
  background-color: transparent;
  background: transparent;
  color: transparent;
  border-top: 0;
  border-right: 0;
  border-bottom: 3px solid #00bcd4;
  border-left: 3px solid #00bcd4;
  content: "";
  width: 17px;
  height: 8px;
  border-radius: 0;
  transform: rotate(-45deg);
  position: absolute;
  top: 2px;
  right: -27px;
  z-index: 1;
  box-shadow: none;
}
</style>
